export const payment = {
  paymentForm: {
    payment: 'Payment',
    choosePaymentMethod: 'Choose a payment method',
    paymentType: 'Payment Type',
    accountHolderName: {
      label: 'Account Holder Name',
      placeholder: 'Account Holder Name',
    },
    cardNumber: 'Card Number',
    expirationDate: 'Expiration Date',
    securityCode: 'Security Code (CVV)',
    securityCodeTitle: 'Card Verification Value',
    saveAsDefault: 'Save as default',
    setAsDefault: 'Set as default payment method',
    billingAddress: 'Billing Address',
    sameAsDeliveryAddress: 'Same as delivery address',
    billingAddressSameAsShipping: 'Billing address is the same as shipping address',
    selectOne: 'Select One...',
    monthMask: 'MM',
    yearMask: 'YYYY',
    expirationYear: 'Expiration year {{ selected }}',
    expirationMonth: 'Expiration month {{ selected }}',
    useThisPayment: 'Use this payment',
    addNewPayment: 'Add New Payment',
    paymentAddedSuccessfully: 'New payment was added successfully',
    changePayment: 'Change Payment',
  },
  paymentMethods: {
    paymentMethods: 'Payment Information',
    paymentMethodSelected: 'Selected payment method',
    newPaymentMethodsAreAddedDuringCheckout: 'New payment methods are added during checkout.',
    invalidField: 'Invalid field: {{ field }}',
  },
  paymentCard: {
    deleteConfirmation: 'Are you sure you want to delete this payment method?',
    setAsDefault: 'Set as default',
    expires: 'Expires on: {{ month }}/{{ year }}',
    defaultPaymentMethod: '✓ DEFAULT',
    defaultPaymentLabel: 'Default payment method',
    additionalPaymentLabel: 'Additional payment method {{ number }}',
    selected: 'Selected',
    deletePaymentSuccess: 'Payment method deleted successfully',
  },
  paymentTypes: {
    title: 'Payment Information',
    paymentType_CARD: 'Credit Card',
    paymentType_ACCOUNT: 'Account',
  },
  paymentMessages: {
    setAsDefaultSuccessfully: 'New payment was successfully set as default',
  },
  paymentHistory: {
    searchConfiguration: 'Search Configuration',
    searchBy: 'Search By:',
    searchType: 'Search Type:',
    enterPaymentNumber: 'Enter Payment Number',
    enterAmount: 'Enter Amount',
    search: 'Search',
    myRecentPayment: 'My Recent Payment',
    noPaymentsFound: 'No payments found',
    paymentHistoryDetails: 'Payment History Details',
    yourPayment: 'Your Payment#',
    receiptDate: 'Receipt Date',
    paymentAmount: 'Payment Amount',
    appliedAmount: 'Applied Amount',
    invoiceDate: 'Invoice Date',
    discountTaken: 'Discount Taken',
    dateApplied: 'Date Applied',
    amountDueRemaining: 'Amount Due Remaining',
    close: 'Close',
  },
};